<template>
		<dl class="generalPriceInfo sort-item" v-if="!(ptInitData.siteKbn == '4' && !ptInitData.loginKbn && ptInitData.priceShowBtoB == 0) && ptInitData.priceShow != 1">
			<dt v-if="ptInitData.productInfo.POINT_ITEM_KBN == '0' || ptInitData.productInfo.POINT_ITEM_KBN == '2'">
				<label>
					<!-- <input type="radio" id="generalKounyuu" class="teikiRadio" name="teikiKounyuu" value="0"
					v-model="teikiKounyuu"
					v-if="ptInitData.teikiKounyuuOption == 1 && ptInitData.productInfo.TEIKI_KOUNYUU_KANOU_FLG == 1"> -->
					<template
						v-if="ptInitData.teikiKounyuuOption == 1 && ptInitData.productInfo.TEIKI_KOUNYUU_KANOU_FLG == 1">
						{{ $t('pt125.labels.generalLabel') }}</template>
					<span class='generalPriceTitle'>{{ $t('common.labels.price') }}</span>

				</label>
			</dt>
			<template
				v-if="ptInitData.productInfo.POINT_ITEM_KBN == '0' || ptInitData.productInfo.POINT_ITEM_KBN == '2'">
				<!-- 販売価格 標準価格(税込) -->
				<dd v-if="ptInitData.productInfo.TAX_KBN == 1">
					<span class="generalPrice">{{ formatPrice(ptInitData.productInfo.SALE_ZEI_K_TNK) }}{{
						$t('common.labels.jpYen') }}</span>
					&nbsp;<template v-if="ptInitData.productInfo.ITEM_ZEI_SET_KBN != '0'"><span
							class="generalPriceZei">{{
								$t('common.labels.taxIncludeSale[1]') }}</span></template>
				</dd>
				<dd v-else>
					<!--税抜価格-->
					<span class="generalPrice">{{ formatPrice(ptInitData.productInfo.SALE_TNK) }}{{
						$t('common.labels.jpYen')
					}}</span>&nbsp;
					<template v-if="ptInitData.productInfo.ITEM_ZEI_SET_KBN != '0'">
						<span class="generalPriceZei">{{ $t('common.labels.taxIncludeSale[2]') }}</span>
					</template><br>
					<!--参考価格（税込）-->
					<span class="generalZeiPrice">{{ formatPrice(ptInitData.productInfo.SALE_ZEI_K_TNK) }}{{
						$t('common.labels.jpYen')
					}}</span>&nbsp;
					<template v-if="ptInitData.productInfo.ITEM_ZEI_SET_KBN != '0'">
						<span class="generalPriceZeiKomi">{{ $t('common.labels.taxIncludeSale[1]') }}</span>
					</template>
				</dd>
			</template>

		</dl>
</template>
<script>
import cartContainer from './cartContainer.vue'
import common from "assets/js/common";
export default {
	name: 'GeneralPriceInfo',
	components: {
		cartContainer
	},
	props: {
		ptInitData: {
			type: Object,
			default: null,
		},
		doChkCartAddTxt: {
			type: Boolean
		},
		isLp: {
			type: Boolean,
			default: false
		},
		teikiKounyuu: {
			type: Number,
			default: 0
		}
	},
	data: function () {
		return {
		}
	},
	methods: {
		/**
		 * format number value to currency value
		 * @param {number} value, number to format
		 */
		formatPrice: function (value) {
			return common.formatPrice(value);
		},
	}
}
</script>